export class CreatePaymentModel {
  PatientID: string;
  PaymentFromContactID: string;
  PaymentFrom: string;
  PaymentProcessorID: string;
  paymentAmount: number;
  ApprovedPaymentAmount: number;
  enumPaymentSourceID: string;
  enumARPayementTypeID: string;
  enumARPayementETypeID: string;
  enumARPayementCCTypeID: string;
  enumCurrencyID: string;
  Description: string;
  datePostPayment: Date;
  dateReceivedPayment: Date;
  DepositARAccountID: string;
  enumPaymentTransactionTypeID: string;
  LOCID: string;
  PaymentSourceObjectID: string;
}
